import { NavLink, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";


import { LogoComponent } from "./logo";
import { LinkRoutes } from "../data";
import { ButtonComponent } from "../components/Tags/button";
import { motion, AnimatePresence } from "framer-motion";
import { sidebarVariant, transition } from "../variants";
import { MdMenu } from "react-icons/md";
import headerBg from "../assets/headerBg.png";

type componentProps = {
  Component?: React.ComponentType;
  ref?: string;
};

const Header = ({ Component }: componentProps): JSX.Element => {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  const Scroll = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const [isSticky, setIsSticky] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsSticky(window.scrollY > 100);
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  return (
    <>
      {/* Main content with background */}
      <main 
        className="md:p-8 lg:p-10 mb-3 relative min-h-screen"
        style={{
          backgroundImage: `url(${headerBg})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat',
          width: '100%',
          backgroundColor: '#1a5c3a' // Fallback green color
        }}
      >
        {/* Desktop Header - FIXED */}
        <header
          className={`md:flex hidden shadow-xl bg-white/95 backdrop-blur-sm top-5 ${
            isSticky ? "is-sticky" : ""
          } fixed left-0 right-0 mx-3 rounded-md items-center justify-between px-5 z-50`}
        >
          <LogoComponent />
          <nav className="flex font-gsans-medium justify-between mx-auto flex-1 max-w-sm">
            {LinkRoutes.map(({ name, path }) => {
              return (
                <li className="list-none" onClick={Scroll}>
                  <NavLink key={name} to={path}>
                    {name}
                  </NavLink>
                </li>
              );
            })}
          </nav>
          <ButtonComponent
            clickHandler={() => navigate("/login")}
            _style=""
            title="Sell Waste"
            type="dark"
          />
        </header>

        {/* Mobile Header - FIXED */}
        <header
          className={`${
            isSticky ? "is-sticky py-0 w-screen bg-white shadow-lg" : ""
          } py-2 px-0 fixed top-0 left-0 right-0 z-50 md:hidden`}
        >
          <section className="mx-2">
            <nav
              className={`flex shadow-2xl bg-white/95 backdrop-blur-sm rounded-md items-center justify-between px-5`}
            >
              <LogoComponent />
              <span
                onClick={() => setOpen(!open)}
                className=" p-[1.3px] rounded-md cursor-pointer bg-primary"
              >
                {" "}
                <MdMenu size="2rem" color="#fff" />
              </span>
            </nav>

            <AnimatePresence>
              {" "}
              {open && (
                <motion.nav
                  variants={sidebarVariant}
                  transition={transition}
                  initial="hidden"
                  animate="visible"
                  className=" shadow-2xl font-gsans-medium flex-col gap-5 rounded-md my-4 p-3 flex items-center justify-center bg-white"
                >
                  {LinkRoutes.map(({ name, path }) => {
                    return (
                      <li className="list-none" onClick={Scroll}>
                        <NavLink
                          className=" font-semibold font-gsans-light "
                          key={name}
                          to={path}
                        >
                          {name}
                        </NavLink>
                      </li>
                    );
                  })}
                  <ButtonComponent
                    clickHandler={() => navigate("/login")}
                    _style="px-3"
                    title="Sell Waste"
                    type="dark"
                  />
                </motion.nav>
              )}
            </AnimatePresence>
          </section>
        </header>

        {/* Component content with padding for fixed header */}
        {Component && (
          <div className="py-5 pt-24 md:pt-32 relative z-10">
            <Component />
          </div>
        )}
      </main>
    </>
  );
};

export default Header;